import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AuthenticationService } from 'app/services';

@Component({
  selector: 'activities-search',
  templateUrl: './activities-search.component.html',
  styleUrls: ['./activities-search.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ActivitiesSearchComponent implements OnInit {

  form: UntypedFormGroup;
  user: any;


  constructor(
    public matDialogRef: MatDialogRef<ActivitiesSearchComponent>,
    private _authenticationService: AuthenticationService,
    private formBuiler: UntypedFormBuilder,
  
  ) {
    this.user = this._authenticationService.currentUserValue;
    this.form = this.formBuiler.group({
      type : (' '),
      fullName: (' '),
      email : (''),
      assignedTo : (''),
      language : (''),
      date_from : (''),
    });
  }

  ngOnInit(): void {
    
  }

}
